import { HttpClient } from '@angular/common/http';
import { Component, Injectable, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OpenIdProfileInterface } from 'src/app/interface/open-id-profile.interface';
import { OpenIdService } from 'src/app/service/open-id.service';
import { PaymentComponent } from 'src/app/dialog/ledger/payment/payment.component';

class SomeConcrete {
    constructor(private httpClient: HttpClient) {}
}

interface Summary {
    count: number;
    amount: number;
}

interface TransactionTypeSummary {
    transaction_type: string;
    sender: Summary;
    receiver: Summary;
}

interface Response {
    summary: TransactionTypeSummary[];
    success: number;
}

@Component({
    selector: 'app-index',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.css'],
})
export class IndexComponent implements OnInit {
    public openIdProfile?: OpenIdProfileInterface;

    public summary: TransactionTypeSummary[] = [];

    constructor(
        private httpClient: HttpClient,
        private dialog: MatDialog,
        private openIdService: OpenIdService
    ) {}

    ngOnInit(): void {
        this.openIdService.$userProfile.subscribe(
            (openIdProfile: OpenIdProfileInterface) => {
                if (!openIdProfile) return;
                this.openIdProfile = openIdProfile;
                this.updateSummary();
            }
        );
    }

    public payment() {
        const dialogRef = this.dialog.open(PaymentComponent);
    }

    private updateSummary() {
        this.httpClient
            .get<Response>('ledger/summary')
            .subscribe((response: Response) => {
                this.summary = response.summary;
            });
    }
}
